import Vue from "vue";
import { Prop, Inject } from "vue-property-decorator";

export default class Base extends Vue {
  @Inject()
  private bus;
  @Prop()
  protected prop!: IProp;

  @Prop()
  protected model!: object;

  @Prop()
  protected index!: number;
  @Prop()
  protected multiple!: boolean;
}
